import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { NSUnitTrainDialogsConstants } from '@ruby/configs/unit-train-dialogs.constants';
import { IUTFleetDetail } from '@ruby/modules/unit-train/models/unit-train.interface';

@Component({
  selector: 'ng-fleet-details-dialog',
  styleUrls: ['./fleet-details.dialog.scss'],
  templateUrl: './fleet-details.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FleetDetailsDialog {
  @Input() data: Array<IUTFleetDetail> = [];
  @Input() loading!: boolean;
  @Output() refresh = new EventEmitter();
  gridConfigs = NSUnitTrainDialogsConstants.fleetDetailsGridConfigs;

  constructor() {
  }
}
